import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { SwitcherWrapper, LangBtn, Sep } from "./styles";

const LANGS = [
  { code: "es", label: "ES", ariaLabel: "Cambiar a Español" },
  { code: "en", label: "EN", ariaLabel: "Switch to English" },
];

const LanguageSwitcher = () => {
  const { i18n: { language } } = useTranslation();

  const isActive = (code: string) =>
    language === code || language.startsWith(code + "-");

  const handleChange = (code: string) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem("i18nextLng", code); } catch {}
    document.documentElement.lang = code;
  };

  return (
    <SwitcherWrapper role="group" aria-label="Seleccionar idioma / Select language">
      {LANGS.map((lang, i) => (
        <Fragment key={lang.code}>
          {i > 0 && <Sep aria-hidden="true">/</Sep>}
          <LangBtn
            onClick={() => handleChange(lang.code)}
            $active={isActive(lang.code)}
            aria-label={lang.ariaLabel}
            aria-pressed={isActive(lang.code)}
            type="button"
          >
            {lang.label}
          </LangBtn>
        </Fragment>
      ))}
    </SwitcherWrapper>
  );
};

export default LanguageSwitcher;
